import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let lightTheme = createTheme({
  typography: {
    fontFamily: [
      'Playfair Display',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  palette: {
    primary: { main: "#ff8c69" },
    secondary: { main: "#141414" },
    complementary: { main: "#6cbdfc" },
    tagline: { main: "#420606" },
    cardBg:{main:'#0dac5'},
    titleColor:{main:"#1e376d"},
    background: {
      default: "#e4f0e2",
    },
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h2",
          h2: "h2",
          h3: "h2",
          h4: "h2",
          h5: "h2",
          h6: "h2",
          subtitle1: "h2",
          subtitle2: "h2",
          body1: "span",
          body2: "span",
        },
      },
    },
  },
});
lightTheme = responsiveFontSizes(lightTheme);

export default lightTheme;
